// import node module libraries
import { Fragment, useEffect, useState } from 'react';
import { Col, Row, Breadcrumb, Card, Form, Button, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

// Import authentication components
import useAuthHeader from 'react-auth-kit/hooks/useAuthHeader';
import useAuthUser from 'react-auth-kit/hooks/useAuthUser';

// import notification component
import Notification, { handleShowNotification } from 'components/elements/notification/Notification';

const AllAdminEmail = ({ activeKey }) => { // activeKey als Prop erhalten
	const { t } = useTranslation(); // useTranslation-Hook
	const [notification, setNotification] = useState({ variant: '', title: '', message: '' });
	const [isLoading, setIsLoading] = useState(true); // State for loading table
	const [isLoadingButton, setIsLoadingButton] = useState(false); // State for loading spinner
	const [isButtonDisabled, setIsButtonDisabled] = useState(false); // State for button disabled when loading
	const [isLoadingButtonSMTPTest, setIsLoadingButtonSMTPTest] = useState(false); // State for loading spinner
	const [isButtonDisabledSMTPTest, setIsButtonDisabledSMTPTest] = useState(false); // State for button disabled when loading

	const auth = useAuthUser(); // Assuming this gets the auth user data

	const [formData, setFormData] = useState({
		config_key: '',
		config_value: {
			auth: {
				smtp_auth_pass: '',
				smtp_auth_type: '',
				smtp_auth_user: '',
			},
			smtp_host: '',
			smtp_port: '',
			smtp_secure: '',
		}
	});
	const [data, setData] = useState(null); // Add data state

	// API-Call Options
	const authHeader = useAuthHeader();
	const options = {
		params: {

		},
		headers: {
			Authorization: authHeader,
			Accept: 'application/json'
		}
	};

	// API-Call for all Data
	const getData = async () => {
		setIsLoading(true);
		
		// Dynamische URL basierend auf der Umgebung
		const baseURL = process.env.REACT_APP_ENV === 'development'
			? `http://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`
			: `https://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`;

		await axios.get(`${baseURL}/configs/6da22e08-9b59-11ef-8d7a-0242ac120009`, options)
			.then(response => {
				const responseData = response.data.data; // Extract and deep clone the data from the response

				setData({ data: responseData });
				setFormData({
					config_key: responseData.config_key || '',
					config_value: {
						auth: {
							pass: responseData.config_value.auth.pass || '',
							type: responseData.config_value.auth.type || '',
							user: responseData.config_value.auth.user || '',
						},
						host: responseData.config_value.host || '',
						port: responseData.config_value.port || '',
						secure: responseData.config_value.secure,
					}
	
					
	
				});
				setIsLoading(false);
			})
			.catch((error) => {
				const errorMessage = error.response?.data?.message ? error.message + '. ' + error.response.data.message : error.message;
				handleShowNotification(setNotification, 'danger', 'Fehler', errorMessage + '. Bitte versuche es erneut oder kontaktiere den HelpDesk.');
				setIsLoading(false);
			});
	};

	useEffect(() => {
		// Check if the current tab is active before making the API call
		if (activeKey === 'smtp') {
			getData();
		}
	}, [activeKey]); // Run effect when activeKey changes

	const handleChange = (e) => {
		setIsButtonDisabledSMTPTest(true);
		setIsLoadingButtonSMTPTest(false);

		const { id, value, type, checked } = e.target;
		const newValue = type === 'checkbox' ? checked : value;

		// Update the form data
		setFormData((prevFormData) => {
			const updatedFormData = { ...prevFormData };
			if (id.startsWith('smtp_auth_')) {
				updatedFormData.config_value.auth[id.replace('smtp_auth_', '')] = newValue;
			} else {
				updatedFormData.config_value[id.replace('smtp_', '')] = newValue;
			}
			return updatedFormData;
		});
	};

	// Handle form submission
	const handleUpdateSMTPConfig = async (e) => {
		e.preventDefault();
		setIsLoadingButton(true);
		setIsButtonDisabled(true);
		setIsButtonDisabledSMTPTest(false);
		// Dynamische URL basierend auf der Umgebung
		const baseURL = process.env.REACT_APP_ENV === 'development'
			? `http://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`
			: `https://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`;

		await axios.patch(`${baseURL}/configs/6da22e08-9b59-11ef-8d7a-0242ac120009`, formData, options)
			.then(response => {
				setData({ data: response.data.data });
				setIsLoadingButton(false);
				setIsButtonDisabled(false);
				handleShowNotification(setNotification, 'success', 'Erfolgreich', 'Deine Daten wurden erfolgreich gespeichert');
			})
			.catch((error) => {
				setIsLoadingButton(false);
				setIsButtonDisabled(false);
				const errorMessage = error.response?.data?.message ? error.message + '. ' + error.response.data.message : error.message;
				handleShowNotification(setNotification, 'danger', 'Fehler', errorMessage + '. Bitte versuche es erneut oder kontaktiere den HelpDesk.');
			});
	};

	const handleSMTPTest = async (e) => {
		e.preventDefault();
		setIsLoadingButtonSMTPTest(true);
		setIsButtonDisabledSMTPTest(true);

		const body = {
			email_template_id: "c2eda604-cf7a-11ef-8d7a-0242ac120009",
			message: {
				from: "haeppy.app <noreply@haeppy.app>",
				to: auth.username,
				variables: {
				}
			}
		};

		// Dynamische URL basierend auf der Umgebung
		const baseURL = process.env.REACT_APP_ENV === 'development'
			? `http://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`
			: `https://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`;

		await axios.post(`${baseURL}/email/send-email`, body, options)
			.then(response => {
				setData({ data: response.data.data });
				setIsLoadingButtonSMTPTest(false);
				setIsButtonDisabledSMTPTest(false);
				handleShowNotification(setNotification, 'success', 'Erfolgreich', 'Die eingegbenen SMTP Einstellungen sind korrekt. Du solltest in kürze eine Test E-Mail erhalten.');
			})
			.catch((error) => {
				setIsLoadingButtonSMTPTest(false);
				setIsButtonDisabledSMTPTest(false);
				const errorMessage = error.response?.data?.message ? error.message + '. ' + error.response.data.message : error.message;
				handleShowNotification(setNotification, 'danger', 'Fehler', errorMessage );
			});
	};

	return (
		<Fragment>
			{notification.show && (
				<Notification variant={notification.variant} title={notification.title} message={notification.message} show={notification.show} setNotification={setNotification} />
			)}
			<Row>
				<Col xl={{ offset: 1, span: 10 }} lg={{ offset: 1, span: 10 }} md={12}>
					<Card>
						<Card.Header className="d-flex justify-content-between">
							<h4 className="mb-0">{t('SMTP Server')}</h4>
							<span>{t('Configure SMTP Server settings to send emails')}</span>
						</Card.Header>
						<Form onSubmit={handleUpdateSMTPConfig}>
						<Card.Body>
							{isLoading ? (
								<div className="d-flex justify-content-center">
									<Spinner animation="border" role="status">
										<span className="visually-hidden">Loading...</span>
									</Spinner>
								</div>
							) : (
								<Row>
									<Col lg={6} md={12} className="mb-3">
										{/* Hostname */}
										<Form.Label>
											{t('Hostname')}<span className="text-danger">*</span>
										</Form.Label>
										<Form.Control
											type="text"
											id="smtp_host"
											placeholder=""
											value={formData.config_value.host} 
											onChange={handleChange}
											required
										/>
									</Col>
									<Col lg={6} md={12} className="mb-3">
										{/* Port */}
										<Form.Label>
											{t('Port')}<span className="text-danger">*</span>
										</Form.Label>
										<Form.Control
											type="text"
											id="smtp_port"
											placeholder=""
											value={formData.config_value.port}
											onChange={handleChange}
											required
										/>
									</Col>
									<Col lg={6} md={12} className="mb-3">
										{/* Auth */}
										<Form.Label>
											{t('Auth type')}<span className="text-danger">*</span>
										</Form.Label>
										<Form.Control
											type="text"
											id="smtp_auth_type"
											placeholder=""
											value={formData.config_value.auth.type}
											onChange={handleChange}
											required
										/>
									</Col>
									<Col lg={6} md={12} className="mb-3">
										{/* Encryption */}
										<Form.Label>
											{t('Encryption')}<span className="text-danger">*</span>
										</Form.Label>
										<Form.Check
											type="checkbox"
											id="smtp_secure"
											label="TLS / SSL"
											className=" form-switch"
											value={formData.config_value.secure}
											onChange={handleChange}
											checked={formData.config_value.secure}
										/>
									</Col>
									<Col lg={6} md={12} className="mb-3">
										{/* Username */}
										<Form.Label>
											{t('Username')}<span className="text-danger">*</span>
										</Form.Label>
										<Form.Control
											type="text"
											id="smtp_auth_user"
											placeholder=""
											value={formData.config_value.auth.user}
											onChange={handleChange}
											required
										/>
									</Col>
									<Col lg={6} md={12} className="mb-3">
										{/* Password */}
										<Form.Label>
											{t('Password')}<span className="text-danger">*</span>
										</Form.Label>
										<Form.Control
											type="passwird"
											id="smtp_auth_pass"
											placeholder=""
											value={formData.config_value.auth.pass}
											onChange={handleChange}
											required
										/>
									</Col>
								</Row>
							)}
						</Card.Body>
						<Card.Footer className="d-flex justify-content-end">
							<Button className="d-end me-2" variant="outline-primary" onClick={handleSMTPTest} disabled={isButtonDisabledSMTPTest}>
								{isLoadingButtonSMTPTest ? (
									<>
										<Spinner animation="border" size="sm" className="me-2" />
										{t('Test settings')}
									</>
								) : (
									t('Test settings')
								)}
							</Button>
							<Button className="d-end" variant="primary" type="submit" disabled={isButtonDisabled}>
								{isLoadingButton ? (
									<>
										<Spinner animation="border" size="sm" className="me-2" />
										{t('Save')}
									</>
								) : (
									t('Save')
								)}
							</Button>
						</Card.Footer>
						</Form>
					</Card>
				</Col>
			</Row>
		</Fragment>
	);
};

export default AllAdminEmail;
